module.exports = __webpack_public_path__ + "media/images/logo-lucasistencia-a1f98a5fe78425ac7f0bd2f16ce03ad3.png";